import React from "react";
import {Animated, Dimensions} from "react-native";

/*
 * VirtualizedList: You have a large list that is slow to update - make sure your renderItem function
 * renders components that follow React performance best practices like PureComponent, shouldComponentUpdate, etc.
 *
 *
 */


class Indicator extends React.Component{
    constructor(props) {
        super(props);
        this.data = this.props.data;
    }


    render() {
        const scrollX = this.props.scrollX;
        const measures = this.props.measures;

        const inputRange = this.props.tabcontent_widths;

        const indicatorWidth = scrollX.interpolate({
            inputRange,
            outputRange : measures.map((measure)=>measure.width+38)
        });

        const translateX = scrollX.interpolate({
            inputRange,
            outputRange : measures.map((measure)=>measure.x-19)
        });


        return <Animated.View style={{
            position:"absolute",
            height:0,
            width:indicatorWidth,
            backgroundColor:'#0071F5',
            bottom:-24,
            padding:15,
            borderRadius:22,
            left:0,
            transform : [{translateX : translateX}]
        }} />
    }
}

export default Indicator;
